const { ProxifiedEntityApi } = require('../common')
const OrganisationPGAdapter = require('./data-access/organisation-pg-adapter')

class OrganisationApi extends ProxifiedEntityApi {
  constructor (state, pgConnection, agaveAdapter, logger) {
    const { user } = state

    const adapter = new OrganisationPGAdapter(logger, pgConnection, user.name)
    super(
      'organisation',
      ['create', 'update', 'list', 'get', 'listOwned'],
      !pgConnection,
      adapter,
      agaveAdapter
    )

    this.adapter = adapter
    this.user = user
  }

  async listOwned ({ type } = {}) {
    const owningOrganisationId = this.user && this.user.organisationId
    if (!owningOrganisationId) {
      throw new Error('listOwned requires a user with organisationId')
    }

    const filter = { owning_organisation_id: owningOrganisationId }
    if (type) filter.type = type

    return this.adapter.getList({ filter })
  }

  /**
   * Returns the name of an organisation, or `null` when there is none to
   * return.
   *
   * Callers only interested in the name — reporting, log enrichment — should
   * not have to handle the 404 that `getOne` throws, nor an id that is simply
   * not set on the record they came from, so both are reported as `null`.
   */
  async getOrganisationName (organisationId) {
    if (!organisationId) {
      return null
    }

    const [organisation] = await this.adapter.getList({ filter: { id: organisationId } })

    return organisation ? organisation.name : null
  }

  async getOrganisationIdFromName (name, type = null) {
    const filter = { name }
    if (type) {
      filter.type = type
    }

    const organisations = await this.adapter.getList({ filter })

    if (!organisations.length) {
      throw new Error(`Organisation not found: ${JSON.stringify({ name, type })}`)
    }

    return organisations[0].id
  }
}

module.exports = OrganisationApi
